/**
 * FX 数字格式化工具
 */

/**
 * 格式化金额（分 → 美元字符串）
 *
 * @param {number} cents 金额（分）
 * @returns {string} 格式化金额，如 $10,000.00
 */
export function fmtMoney(cents) {
	const dollars = (cents || 0) / 100
	const formatted = dollars.toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	})
	return '$' + formatted
}

/**
 * 格式化百分比
 *
 * @param {number} decimal 小数（如 0.04）
 * @returns {string} 格式化百分比，如 4.00%
 */
export function fmtPercent(decimal) {
	if (decimal == null) {
		return '-'
	}
	return (decimal * 100).toFixed(2) + '%'
}

/**
 * 格式化价格
 *
 * @param {number} price 价格
 * @returns {string} 格式化价格
 */
export function fmtPrice(price) {
	if (price == null || isNaN(price)) {
		return '-'
	}
	return price.toFixed(4)
}

/**
 * 格式化方向
 *
 * @param {string} direction long/short
 * @returns {string} 做多/做空
 */
export function fmtDirection(direction) {
	return direction === 'long' ? '做多' : '做空'
}

/**
 * 格式化带符号金额（含 +/-）
 *
 * @param {number} cents 金额（分）
 * @returns {string} 格式化金额
 */
export function fmtSignedMoney(cents) {
	const value = (cents || 0) / 100
	const sign = value > 0 ? '+' : (value < 0 ? '-' : '')
	return sign + fmtMoney(Math.abs(cents || 0))
}
